import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { Fade, IconButton, TableSortLabel } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { WalletFilters, WalletListItem } from '../../types/wallet'
import { WalletSortBy } from '../../types/walletEnums'
import { WalletListTableRowDesktop } from './WalletListTableRowDesktop'
import { WalletListRowDesktopSkeleton } from './WalletListTableRowDesktop.Skeleton'
import useStyles from './styles/WalletListTableDesktop.styles'

interface BookingListTableProps {
  data: WalletListItem[]
  loadingForWallets?: boolean
  setSort: React.Dispatch<React.SetStateAction<WalletSortBy>>
  sort: WalletSortBy
  setPage: React.Dispatch<React.SetStateAction<number>>
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      wallets: WalletListItem[]
    }>
  >
  filters: WalletFilters
  setfilters: (v: WalletFilters) => void
}
export const WalletListTableDesktop: React.FC<BookingListTableProps> = ({
  data,
  setSort,
  sort,
  refetch,
  setPage,
  loadingForWallets,
  filters,
  setfilters
}) => {
  const classes = useStyles()
  interface HeadCell {
    label: string
    id: string
  }
  const headCells: HeadCell[] = [
    { id: '1', label: 'Entity' },
    { id: '2', label: 'Entity Type' },
    { id: '3', label: 'Currency' },
    { id: '4', label: 'Type' },
    { id: 'wallet', label: 'Wallet Cash Balance' },
    { id: 'credit', label: 'Remaining Credit' },
    { id: '5', label: 'Active' }
  ]

  return (
    <div>
      <div className={classes.tableHead}>
        {headCells.map((item) => (
          <div key={item.id}>
            <TableSortLabel
              className={classes.tableSortLabel}
              active={
                item.id === 'wallet' || item.id === 'credit' ? true : false
              }
              onClick={() => {
                setSort(
                  item.id === 'wallet' || item.id === 'credit'
                    ? item.id
                    : 'decwallet'
                )
                setfilters({
                  ...filters,
                  sortBy:
                    item.id === 'wallet' || item.id === 'credit'
                      ? item.id
                      : 'decwallet'
                })
                if (sort === item.id) {
                  setSort(('dec' + item.id) as WalletSortBy)
                  setfilters({
                    ...filters,
                    sortBy: ('dec' + item.id) as WalletSortBy
                  })
                }
              }}
              hideSortIcon
              direction={item.id === sort ? 'desc' : 'asc'}>
              {getTranslate(item.label)}
            </TableSortLabel>
          </div>
        ))}

        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              setPage(1)
              refetch()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loadingForWallets
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <WalletListRowDesktopSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleWallet: WalletListItem) => (
            <Fade in timeout={600} key={singleWallet.walletID}>
              <WalletListTableRowDesktop data={singleWallet} />
            </Fade>
          ))}
    </div>
  )
}
